module.exports = __webpack_public_path__ + "img/29.ef1223ab.png";